import React from 'react';
import styled from 'styled-components/macro';
import { DeviceSize } from '../../basic/DeviceSize';
import { Button } from '..';
import { useMessageGetter } from 'react-message-context';

const FormActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FormRow = styled.div`
  display: flex;
  gap: 20px;
  @media ${DeviceSize.mobileL} {
    flex-direction: column;
  }
`;

const ActionButtonsRow = styled(FormRow)`
  margin-top: 8px;
  padding-top: 24px;
  justify-content: space-between;
  border-top: 1px solid black;
  @media ${DeviceSize.mobileL} {
    flex-direction: column;
  }
`;

const EmptyFormText = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

type Props = {
  handleTogglePreview?: () => void;
  handleSave: () => void;
  handleSubmitFinal: () => void;
  handleEmptyForm: () => void;
  previewOpen?: boolean;
  actionButtonType?: 'publish' | 'send';
  disabled: boolean;
};

export const FormActions = ({
  handleTogglePreview,
  handleSave,
  handleSubmitFinal,
  handleEmptyForm,
  previewOpen = false,
  actionButtonType = 'publish',
  disabled = false,
}: Props) => {
  const t = useMessageGetter('forms');
  return (
    <FormActionsContainer>
      <ActionButtonsRow>
        <FormRow>
          {handleTogglePreview && (
            <Button
              onClick={handleTogglePreview}
              icon={previewOpen ? 'edit' : 'eye'}
              type="button"
              id="preview"
              disabled={disabled}
            >
              {t(previewOpen ? 'closePreview' : 'preview')}
            </Button>
          )}
          {!previewOpen && (
            <Button onClick={handleSave} icon="saveOutlined" type="button" id="save" disabled={disabled}>
              {t('save')}
            </Button>
          )}
        </FormRow>
        {!previewOpen && (
          <FormRow>
            {actionButtonType === 'publish' && (
              <Button
                onClick={handleSubmitFinal}
                primary
                icon="shareFilled"
                type="button"
                id="publish"
                disabled={disabled}
              >
                {t('publish')}
              </Button>
            )}
            {actionButtonType === 'send' && (
              <Button onClick={handleSubmitFinal} primary icon="send2" type="button" id="send" disabled={disabled}>
                {t('send')}
              </Button>
            )}
          </FormRow>
        )}
      </ActionButtonsRow>
      <FormRow>
        <EmptyFormText onClick={handleEmptyForm}>{t('emptyForm')}</EmptyFormText>
      </FormRow>
    </FormActionsContainer>
  );
};
